import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector, shallowEqual } from 'react-redux';

import { usePageElements } from '@Services/Editor';
import { useProjectByProjectId } from '@Services/Projects';

import ProjectTitle from '@Components/Editor/SideBar/ProjectTitle';
import Tab from '@Components/Editor/SideBar/Tab';
import Bottom from '@Components/Editor/SideBar/Bottom';
import Resizable from './Resizable';

const SideBar = ({
  isDataFetching,
  projectId,
  scrollToTargetProcess,
  ReactPaginateCompo,
  currentItems,
  searchPidFunc,
}) => {
  const { name: title } = useSelector(useProjectByProjectId(projectId), shallowEqual);
  const pageElements = useSelector(usePageElements, shallowEqual);

  const matchedPageElements = pageElements.filter(page => {
    return currentItems.some(item => item.processId === page.pageId);
  });

  const matchedItems = () =>
    currentItems?.reduce((items, { choices }) => {
      choices?.forEach(({ results }) => {
        results?.forEach(({ store, storeHidden }) => {
          if (store || storeHidden) {
            const allItems = [...store, ...storeHidden];

            allItems.forEach(({ name }) => {
              if (!items.includes(name)) {
                items.push(name);
              }
            });
          }
        });
      });

      return items;
    }, []);
  return (
    <Resizable>
      <SideBarContainer>
        <TopContainer>
          <ProjectTitle title={title} projectId={projectId} />
          <Tab
            isDataFetching={isDataFetching}
            pageElements={matchedPageElements}
            itemElements={matchedItems()}
            scrollToTargetProcess={scrollToTargetProcess}
            ReactPaginateCompo={ReactPaginateCompo}
            searchPidFunc={searchPidFunc}
          />
        </TopContainer>

        <Bottom />
      </SideBarContainer>
    </Resizable>
  );
};

SideBar.propTypes = {
  isDataFetching: PropTypes.bool.isRequired,
  projectId: PropTypes.string.isRequired,
  scrollToTargetProcess: PropTypes.func.isRequired,
};

const SideBarContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default SideBar;
